import React from "react";
import "./MerchantDashboard.css";
import { maskValue } from "..";
import { useSelector } from "react-redux";

function AdminBalanceCard({ adminComm }) {
  const showValues = useSelector((s) => s.userReducer.showValues);

  let finalAmount = (
    (adminComm?.payInNet ? adminComm.payInNet : 0) +
    (adminComm?.payoutNet ? adminComm.payoutNet : 0)
  ).toFixed(2);

  return (
    <div className="admin-card">
      <div className="comm-grid">
        <div className="comm-grid-1">
          <div className="admin-comm-data">
            <p className="heading-comm">Super Payin Comission</p>
            <p className="sub-heading-comm">
              ₹{" "}
              {maskValue(
                adminComm?.payInNet
                  ? Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(adminComm?.payInNet)
                  : "0",
                showValues
              )}
            </p>
          </div>
          <div className="admin-comm-data">
            <p className="heading-comm">Super Payout Comission</p>
            <p className="sub-heading-comm">
              ₹{" "}
              {maskValue(
                adminComm?.payoutNet
                  ? Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(adminComm?.payoutNet)
                  : "0",
                showValues
              )}
            </p>
          </div>
          <div className="admin-comm-data">
            <p className="heading-comm">Super Total Comission</p>
            <p className="sub-heading-comm">
              ₹{" "}
              {maskValue(
                Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(finalAmount),
                showValues
              )}
            </p>
          </div>

          <div className="admin-comm-data">
            <p className="heading-comm">Chargeback Amount</p>
            <p className="sub-heading-comm">
              ₹{" "}
              {maskValue(
                adminComm?.reconcilationAmount
                  ? Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(adminComm?.reconcilationAmount)
                  : "0",
                showValues
              )}
            </p>
          </div>

          <div className="admin-comm-data">
            <p className="heading-comm">Chargeback Penalty</p>
            <p className="sub-heading-comm">
              {" "}
              ₹{" "}
              {maskValue(
                adminComm?.reconcilationPenalty
                  ? Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(adminComm?.reconcilationPenalty)
                  : "0",
                showValues
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminBalanceCard;
